// extracted by mini-css-extract-plugin
export var categoria = "styles-module--categoria--3oO7k";
export var gallery = "styles-module--gallery--25mDi";
export var partnerships = "styles-module--partnerships--3-fcC";
export var partnership = "styles-module--partnership--1cbWn";
export var item = "styles-module--item--3uT5T";